import { Inset } from '@doordash/design-language';

var _SizeSemantics, _SizeStrings;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// If any updates are made here, make an equivalent update in `component-fields.d.ts` as well

var Sizes = {
  Small: Inset.Sizes.XxSmall,
  Medium: Inset.Sizes.XSmall,
  Large: Inset.Sizes.Small
};
var SizeSemantics = (_SizeSemantics = {}, _defineProperty(_SizeSemantics, Sizes.Small, 'FieldSmall'), _defineProperty(_SizeSemantics, Sizes.Medium, 'FieldMedium'), _defineProperty(_SizeSemantics, Sizes.Large, 'FieldLarge'), _SizeSemantics);
var SizeStrings = (_SizeStrings = {}, _defineProperty(_SizeStrings, Sizes.Small, 'Small'), _defineProperty(_SizeStrings, Sizes.Medium, 'Medium'), _defineProperty(_SizeStrings, Sizes.Large, 'Large'), _SizeStrings);

export { SizeSemantics, SizeStrings, Sizes };
